export { type FooterMenuGroupsProps, default as FooterMenuGroups } from './FooterMenuGroups';
